import axios from "@axios";


export default {
  namespaced: true,
  state: {
    items: [],
    providers: [],
    fields: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedProviders(state) {
      return state.providers.map((provider) => ({
        provider: provider.provider
      }));
    },
    getFields(state) {
      return state.fields.map((field) => ({
        name: field.name,
        description: field.description,
        fieldType: field.fieldType,
      }));
    },
    getSelectedItems(state) {
      return state.items.map((item) => ({
        value: item.id,
        label: item.name,
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setProviders(state, value) {
      state.providers = value
    },
    setFields(state, value) {
      state.fields = value
    },
    resetFields(state) {
      state.fields = [];
    }
  },
  actions: {

    //getAll Retrieves filter type by default.
    async getFieldSelection({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter`,{ params });

      if (!data) {
        return [];
      }

      commit("setFields", data);
      return data;
    },
    //getProviders Retrieves all filter types with its provider.
    async getProviders({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter`, { params });

      if (!data) {
        return [];
      }

      const uniqueProviders = data.reduce((acc, item) => {
        if (!acc.some(p => p.provider === item.provider)) {
          acc.push({ provider: item.provider });
        }
        return acc;
      }, []);

      commit("setProviders",uniqueProviders);
      return data;
    },

    //getAll Retrieves all filter types for the grid table view.
    async getAll({ commit }, params) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter`, { params });

      if (!data) {
        return [];
      }

      commit("setData", data.data);
      return data;
    },
    //getRule Retrieves a specific filter type given its ID
    async getById({ _ }, id) {
      const { data } = await axios.get(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter/${id}`)
      return data;
    },
    //add Creates a new filter type.
    async add(_, params) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter`, params);

      return data;
    },
    //edit Updates an existing filter type.
    async edit(_, { id, params }) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter/${id}`, params);

      return data;
    },
    //delete Deletes an existing filter type.
    async delete(_, id) {
      const { data } = await axios.post(`${window.__env.VUE_APP_ALARMS_MS_URL}/v1/filter/delete/${id}`);

      return data;
    },

    //clear Clears the stored list of filter type in the state.
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
